// normHelpers.js
// Utilities for working with the 3-level norms object delivered by /LoadTestNormsV2

/**
 * Map legacy program / group data to programKey + ageGroup used in the new norms.
 * @param {string} programLabel  e.g. "Next Level ATHlete", "Student ATHlete", "Forever ATHlete"
 * @param {string} groupLabel    e.g. "8-12", "14-18" (may be empty for Next Level / Forever)
 * @param {number} age           numeric age if available
 * @returns {{ programKey:string, ageGroup:string }}
 */
export function deriveProgramAndAgeGroup(programLabel = '', groupLabel = '', age = null) {
  let programKey = programLabel;
  let ageGroup   = 'Any';

  if (programLabel.includes('Next Level')) {
    programKey = 'Next Level';
    ageGroup   = 'Any';
  } else if (programLabel.includes('Forever')) {
    programKey = 'Forever';
    ageGroup   = '19+';
  } else if (programLabel.includes('Student')) {
    programKey = 'Student';
    ageGroup   = groupLabel.replace('-', '_'); // expect 8-12 etc.
  } else if (programLabel.includes('Rebuild')) {
    programKey = 'Student';
    // derive from age when possible
    if (typeof age === 'number') {
      if (age < 12) ageGroup = '8_12';
      else if (age >= 14) ageGroup = '14_18';
      else ageGroup = '12_14';
    }
  }

  return { programKey, ageGroup };
}

/**
 * Safe lookup for mean/sd in nested norms.
 * @param {string} test          test key e.g. "CMJ_FreeArms"
 * @param {string} programKey    "Student", "Next Level", "Forever"
 * @param {string} ageGroup      "8_12" etc.
 * @param {string} gender        "Male" | "Female"
 * @param {object} normsObj      nested norms dict
 * @returns {{mean:number, sd:number}|{mean:null,sd:null}}
 */
export function getNorm(test, programKey, ageGroup, gender, normsObj) {
  try {
    return normsObj?.[test]?.[programKey]?.[ageGroup]?.[gender] ?? { mean: null, sd: null };
  } catch (_) {
    return { mean: null, sd: null };
  }
} 